import urls, { BuildUrl } from 'src/common/constants/urls';

// Services
import { axiosClient } from 'src/common/services/httpService';
import { SessionParamsI } from 'src/interfaces/coach/wellness';
import { therapyGeneralInfo, UpdateAvailabilitySendData } from 'src/interfaces/therapyInterface';

// Interfaces
// import { SessionParamsI } from 'src/interfaces/coach/wellness';

//get therapy list
export const getTherapyListAction = (therapyParams?: {
  Name?: string;
  page?: number;
  limit?: number;
}) =>
  axiosClient.get(urls['get-therapist-list'], {
    params: {
      Name: therapyParams?.Name,
      page: therapyParams?.page,
      limit: therapyParams?.limit || 10,
    },
  });

// Get Therapist detail
export const getTherapistDetailAction = (therapistId: string) =>
  axiosClient.get(urls['get-therapist-detail'], {
    params: {
      therapistId: therapistId,
    },
  });

//create therapy
export const createTherapistAction = (newCoach: therapyGeneralInfo) =>
  axiosClient.post(urls['post-therapist'], newCoach);

// Delete Therapy
export const deleteTherapistAction = (props: { id: any }) =>
  axiosClient.delete(urls['post-therapist'], {
    params: {
      therapistId: props.id,
    },
  });

// Deactivate/activate therapy
export const updateTherapistStatusAction = (props: {
  therapistId: string | undefined;
  status: boolean;
}) =>
  axiosClient.patch(BuildUrl(urls['update-therapy-status'], Number(props.therapistId)), {
    isThisTherapistActivated: props.status,
  });

//Upload Therapy profile picture
export const uploadTherapyPictureAction = (props: {
  therapistId?: string | undefined;
  profilePicture: FormData;
}) =>
  axiosClient.post(
    BuildUrl(urls['post-therapy-picture'], props.therapistId),
    props.profilePicture,
    {
      headers: { 'Content-Type': `undefined ` },
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );

// Delete therapy profile picture
export const deleteTherapyProfilePictureAction = (therapistId: string | undefined) =>
  axiosClient.delete(BuildUrl(urls['delete-therapy-Profile-Picture'], therapistId));

// Update therapy
export const updateTherapyAction = (props: {
  therapistId: string | undefined;
  updatedTherapist: any;
}) =>
  axiosClient.patch(BuildUrl(urls['update-therapist'], props.therapistId), props.updatedTherapist);

//Get therapy availability
export const getTherapyAvailability = (info: { therapistId: string | number | undefined }) =>
  axiosClient.get(BuildUrl(urls['therapy-availabality'], info.therapistId));

// add availability
export const addAvailabilityBlock = (info: { therapistId: string; data: any }) =>
  axiosClient.post(BuildUrl(urls['therapy-availabality'], info.therapistId), info.data);

// Update AvailabilityBlock
export const updateAvailabilityBlock = (props: {
  therapistId: number | undefined;
  data: UpdateAvailabilitySendData;
}) => axiosClient.patch(`therapists/${props.therapistId}/availability`, props.data);

// Get therapy onboarding questions
export const getTherapyQuestionsAction = () => axiosClient.get(urls['get-therapist-questions']);

// Save therapist answers
export const saveTherapistAnswersRequest = (info: { data: any }) =>
  axiosClient.post(urls['save-therapist-answers'], info.data);
// Get appointments
export const getMyAppointments = (params: SessionParamsI) =>
  axiosClient.get(urls['my-therapist-appointments'], { params });

// Get my availability
export const getMyAvailability = () => axiosClient.get(urls['my-therapist-availability']);
// Update Therapist Answers
export const UpdateTherapistAnswersRequest = (info: { therapistId: any; data: any }) =>
  axiosClient.patch(BuildUrl(urls['update-therapist-answers'], info.therapistId), info.data);
//Get therapy appointments
export const getTherapyAppointments = (info: {
  therapistId: string | number | undefined;
  startDateTime: string;
  endDateTime: string;
}) =>
  axiosClient.get(BuildUrl(urls['get-therapy-appointments'], info.therapistId), {
    params: {
      page: 1,
      limit: 10,
      startDateTime: info.startDateTime,
      endDateTime: info.endDateTime,
    },
  });

// Delete availability
export const deleteAvailabilityBlock = (props: { therapistId: string | undefined; data: any }) =>
  axiosClient.delete(BuildUrl(urls['delete-therapist-availability'], props.therapistId), {
    data: {
      firstAvailabilityIdToDelete: props.data.firstAvailabilityIdToDelete,
      lastAvailabilityIdToDelete: props.data.lastAvailabilityIdToDelete,
    },
  });

// Get Therapist detail
export const getMeTherapist = () => axiosClient.get(urls['get-therapist-me']);

// Update My Therapist Picture
export const uploadCurrenTherapistPictureAction = async (props: { profilePicture: FormData }) => {
  return await axiosClient.post(urls['add-my-therapist-profile-picture'], props.profilePicture, {
    headers: { 'Content-Type': `undefined ` },
    validateStatus: function (status) {
      return status < 500;
    },
  });
};

//Upload Therapy profile picture
export const uploadSessionSummaryAction = (props: {
  appointmentId?: string | undefined;
  sessionSummary: FormData;
  comment?: string | null; // Allow comment to be optional or null
}) => {
  return axiosClient.post(
    BuildUrl(urls['session-summary'], props.appointmentId, props.comment),
    props.sessionSummary,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      validateStatus: function (status) {
        return status < 500;
      },
    },
  );
};

export const getIntakeForm = (appointmentId: number) =>
  axiosClient.get(BuildUrl(urls['download-intake-form'], appointmentId));

export const getDownloadReport = (appointmentId: number) =>
  axiosClient.get(BuildUrl(urls['download-summary-report'], appointmentId));
